import React, { useEffect, useState } from "react";
import '../invoice.css';
import moment from "moment";

const Charges = ({data, onBack, type, onSelect}:any) => {
    const charges = data?.serviceInformation;
    const invoices = data?.invoices;
    // console.log(invoices)
    return (
        <>
        {type===0?(
        <div className="charges">
            <div className="table-header">
                <p className="title" style={{textAlign:'start'}}>Description</p>
                <p className="title">Quantity</p>
                <p className="title">Unit Price (USD)</p>
                <p className="title">Amount (USD)</p>
            </div>
            {charges?.sevices?.map((s:any)=>(
                <div className="table-row" key={s?.description}>
                    <p className="value" style={{textAlign:'start'}}>{s?.description??"-"}</p>
                    <p className="value">{s?.quantity??"-"}</p>
                    <p className="value">$ {s?.unitPrice?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })}</p>
                    <p className="value">$ {s?.amount?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })}</p>
                </div>
            ))}
            <div className="total-row">
                <div/>
                <p className="value">Total Amount</p>
                <p className="value">$ {charges?.totalAmount?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })} USD</p>
            </div>
            <div className="total-row">
                <div/>
                <p className="value">Taxes</p>
                {/* <p className="value">Taxes (5%)</p> */}
                <p className="value">$ {charges?.taxes?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })} USD</p>
            </div>
            <div className="total-row">
                <div/>
                <p className="value">Grand Total</p>
                <p className="value">$ {charges?.grandTotal?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })} USD</p>
            </div>
        </div>
        ):(
            <div className="invoices">
                <div className="table-header">
                    <p className="title" style={{textAlign:'start'}}>Date</p>
                    <p className="title" style={{textAlign:'start'}}>Description</p>
                    <p className="title" style={{textAlign:'start'}}>Invoice Number</p>
                    <p className="title">Amount</p>
                    <p className="title">Balance</p>
                </div>
                {invoices?.map((i:any)=>(
                    <div className="table-row" key={i?.invoiceNumber}>
                        <p className="value" style={{textAlign:'start'}}>{i?.invoiceDate??"-"}</p>
                        <p className="value" style={{textAlign:'start'}}>{i?.product??"-"}</p>
                        <p className="value" style={{textAlign:'start'}}>{i?.invoiceNumber??"-"}</p>
                        <p className="value">{i?.amount?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })??"-"}</p>
                        <p className="value">{i?.amount?.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    })??"-"}</p>
                    </div>
                ))}
          
                <div className="total-row">
                    <div/>
                    <p className="value">Subtotal</p>
                    {/* <p className="value">$ 13,900.00 USD</p> */}
                </div>
                <div className="total-row">
                    <div/>
                    <p className="value">Previous Balance</p>
                    {/* <p className="value">$ 2,400.00 USD</p> */}
                </div>
                <div className="total-row">
                    <div/>
                    <p className="value">Total Amount Due</p>
                    {/* <p className="total">$ 14,595.00 USD</p> */}
                </div>
            </div>
        )}
        </>
    )
}

export default Charges;